import styled from 'styled-components';
import router from 'next/router';

import { useTranslation } from '@hooks';
import { Quantity } from '@components/cart';
import { HideDesktop } from '@components/styles/CommonStyles';
import { Caption, Caption2, Subtitle3 } from '@components/styles/Typography';

const CartProductInfo = ({
    item,
    outOfStock,
    withBorder,
    withoutQuantity,
    showDescription,
    sizes,
}) => {
    const { t, locale, useCurrency } = useTranslation();
    const {
        name,
        images,
        colour,
        quantity,
        id,
        slug,
        pre_order: preOrder,
        total_pack_count: totalPackCount,
        pack_count: addedPackCount,
        discounted_price: discountedPrice,
    } = item;
    const price = useCurrency(discountedPrice);
    const image = images[0]?.urls?.thumb;
    const goProduct = () => {
        router.push(`${t('productSlug')}/${slug[locale]}`);
    };
    if (!item) return <p>Loading...</p>;
    const packCount = item.pack_count;
    return (
        <Wrapper withBorder={withBorder}>
            <img
                src={image}
                onClick={goProduct}
                alt={name}
                role="presentation"
                onKeyPress={goProduct}
            />

            <CartProductWrapper>
                <Description showDescription={showDescription}>
                    <ModalProductTitle onClick={goProduct}>
                        {name[locale]}
                    </ModalProductTitle>
                    <ModalProduct>
                        <Caption2>
                            Size: {sizes}
                            <Caption2
                                color="bgGray50"
                                style={{ marginLeft: '5px' }}
                            >
                                {packCount} of each sizes ({packCount}-
                                {packCount}-{packCount})
                            </Caption2>
                        </Caption2>
                    </ModalProduct>
                    <ModalProduct>
                        <Caption2 color="primaryVariant">
                            {t('color')}: {colour.name[locale]}
                        </Caption2>
                    </ModalProduct>
                    <ModalProduct>
                        <Caption2 color="bgGray50">
                            Unit Price: {price}
                        </Caption2>
                    </ModalProduct>
                </Description>
                {outOfStock && (
                    <TextWrapper>
                        <Caption color="error">{t('cartStockOut')}</Caption>
                    </TextWrapper>
                )}
                <HideDesktop>
                    {!withoutQuantity && (
                        <Quantity
                            quantity={quantity}
                            productID={id}
                            avalaibleStock={totalPackCount}
                            addedPackCount={addedPackCount}
                            preOrder={preOrder}
                        />
                    )}
                </HideDesktop>
            </CartProductWrapper>
            {/* {discountRate === 30 && (
                <DiscountBadge left width="30px" height="30px" />
            )} */}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 10px;
    position: relative;

    img {
        width: 60px;
        height: 90px;
        cursor: pointer;
    }

    @media (max-width: 768px) {
        padding: 0;
        align-items: unset;

        img {
            width: 77px;
            height: 115px;
        }
    }
`;
const Description = styled.div`
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        display: ${({ showDescription }) => !showDescription && 'none'};
        white-space: nowrap;
        max-width: 180px;
    }
`;

const TextWrapper = styled.div`
    p {
        margin: 10px 0 10px 0;

        @media (max-width: 768px) {
            margin: -7px 0 10px 0;
        }
    }
`;

const ModalProductTitle = styled(Subtitle3)`
    margin: 0 0 5px 0;
    text-transform: capitalize;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
`;

const ModalProduct = styled.span`
    display: ${({ flex }) => flex && 'flex'};
    align-items: ${({ flex }) => flex && 'center'};

    span:last-child {
        margin-left: ${({ flex }) => flex && '10px'};
    }
`;
const CartProductWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 18px;
    height: auto;

    @media (max-width: 768px) {
        justify-content: space-between;

        div {
            margin-left: 0;
            margin-top: 5px;
        }
    }
`;
export default CartProductInfo;
